import React from 'react';
import { Link } from 'react-router-dom';
// import './NotFound.css';  // Optional: for styling the 404 page
import './Error.css'
// Home route per role. Read at render time (not module load) so it reflects
// the currently logged-in user.
const homeFor = (t) => {
  switch (t) {
    case '1': return '/admin-home';
    case '2':
    case '8': return '/patient-list';
    case '3': return '/doctor-home';
    case '7': return '/Partner';      // partner / customer
    case '9': return '/signing-home';
    default:  return '/login';
  }
};
const NotFound = () => {
    const verifiertype = localStorage.getItem('verifiertype');
    return (
    <div className="notfound-container">
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>Oops! The page you're looking for doesn't exist.</p>
      <Link
  to={homeFor(verifiertype)}
  className="back-home-link"
>
  Go Back Home
</Link>

    </div>
  );
}

export default NotFound;
